import { useEffect } from 'react';
import { message } from 'antd';
import { useLocation } from 'react-router-dom';
import { registerBackGuard } from './useBackButtonClose';
import { isStandaloneApp } from '../../utills/helpers';

// In the installed home-screen app, Back on the first screen of a session has no
// earlier entry to go to, so Android closes the app. Guard that screen: the first
// Back shows a hint and only a second Back within the window closes the app.

const EXIT_WINDOW_MS = 2000;
let armed = false;
let exitTimer = null;

// React Router numbers its entries from 0 for the first screen of the session.
const isFirstEntry = () => (window.history.state?.idx ?? 0) === 0;

const arm = () => {
  if (armed || exitTimer || !isFirstEntry()) return;
  armed = true;
  registerBackGuard(() => {
    armed = false;
    message.info({ content: 'Press back again to exit', duration: EXIT_WINDOW_MS / 1000 });
    exitTimer = setTimeout(() => {
      exitTimer = null;
      arm();
    }, EXIT_WINDOW_MS);
  });
};

const useStandaloneExitGuard = () => {
  const { key } = useLocation();

  // Re-checked on every navigation so returning to the first screen arms it again.
  useEffect(() => {
    if (isStandaloneApp()) arm();
  }, [key]);
};

export default useStandaloneExitGuard;
